/* eslint-disable react/jsx-props-no-spreading */
import * as React from "react";
import Form from "react-bootstrap/Form";
import { ActionButton } from "components/elements/ActionButton";
import { useForm, SubmitHandler } from "react-hook-form";
import { ErrorSpan } from "components/elements";
import { ImportApi } from "features/brm";
import ReactModal from "react-modal";
import * as ModalStyles from "components/modals/Modal.styles";
import Cancel from "assets/icons/cancelModal.svg";

interface IImportFromFileModalProps {
  kbId: string;
  onHide: () => void;
  show: boolean;
}

interface IInputs {
  kbFile: FileList;
}

export const ImportKbFileModal = ({ kbId, onHide, show }: IImportFromFileModalProps) => {
  const [importMessage, setImportMessage] = React.useState("");
  const [isError, setIsError] = React.useState(false);

  const onHideWrapper = () => {
    setIsError(false);
    setImportMessage("");
    onHide();
  };

  const {
    register,
    handleSubmit,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formState: { errors, isDirty, isValid },
    reset,
  } = useForm<IInputs>({ mode: "onChange" });

  const handleClose = () => {
    reset();
    onHideWrapper();
  };

  const { mutate: importKnowledgeBase } = ImportApi.useImportKnowledgebase();

  const onSubmit: SubmitHandler<IInputs> = (data) => {
    const fileArray = Array.from(data.kbFile);
    if (fileArray.length > 0) {
      importKnowledgeBase(
        { kbId, file: fileArray[0] },
        {
          onSuccess: () => {
            reset();
            onHideWrapper();
            setImportMessage("");
          },
          onError: (error: any) => {
            reset();
            setIsError(true);
            setImportMessage(`Error while attempting to import knowledgebase: ${error.response.text}`);
          },
        }
      );
    }
  };

  return (
    <ReactModal
      isOpen={show}
      onAfterClose={onHideWrapper}
      ariaHideApp={false}
      onRequestClose={() => handleClose()}
      style={ModalStyles.defaultModalStyles}
    >
      <ModalStyles.HeaderFlex>
        <ModalStyles.ModalTitle>Import a Knowledgebase</ModalStyles.ModalTitle>
        <ModalStyles.ButtonsDiv>
          <ModalStyles.Close onClick={() => handleClose()}>
            <ModalStyles.CloseIcon src={Cancel} />
          </ModalStyles.Close>
        </ModalStyles.ButtonsDiv>
      </ModalStyles.HeaderFlex>
      <ModalStyles.Body>
        <Form>
          <Form.Label>Select a KB file to import</Form.Label>
          <Form.Group className="mb-3">
            <Form.Control accept=".csv,.json" type="file" {...register("kbFile", { required: true })} />
          </Form.Group>
        </Form>
        {isError ? <ErrorSpan>ERROR: {importMessage}</ErrorSpan> : importMessage}
      </ModalStyles.Body>
      <ModalStyles.Footer>
        <ActionButton onClick={handleClose}>Close</ActionButton>
        <ActionButton onClick={handleSubmit(onSubmit)} disabled={!isDirty || !isValid}>
          Import
        </ActionButton>
      </ModalStyles.Footer>
    </ReactModal>
  );
};
